// This icon file is generated automatically.
var PPauseOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M2.75.75H4v10.5H2.75V.75zm6.38 0h-1A.13.13 0 008 .88v10.24c0 .07.06.13.13.13h1c.06 0 .12-.06.12-.13V.88a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-pause", "theme": "outlined" };
export default PPauseOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPauseOutlined.js
// module id = 3531
// module chunks = 0